export function setDragging(val) {
  // Sets the dragging value of state on element that is bound to. Used by draggable components.
  var that = this;
  setTimeout(function () { //this is a workaround for html5 being stupid.
    that.setState({dragging: val});
  }, 1);

}
